import { render, staticRenderFns } from "./default.vue?vue&type=template&id=228d184a&scoped=true&"
import script from "./default.js?vue&type=script&lang=js&"
export * from "./default.js?vue&type=script&lang=js&"
import style0 from "./default.vue?vue&type=style&index=0&id=228d184a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228d184a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('228d184a')) {
      api.createRecord('228d184a', component.options)
    } else {
      api.reload('228d184a', component.options)
    }
    module.hot.accept("./default.vue?vue&type=template&id=228d184a&scoped=true&", function () {
      api.rerender('228d184a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/supplier/default/default.vue"
export default component.exports